import * as React from "react";
import MDEditor from "@uiw/react-md-editor";
import {INlpAnswerTextInputProps} from "./~types/INlpAnswerTextInputProps";
import { INlpAnswerTextInputState } from "./~types/INlpAnswerTextInputState";
import { ShadowWrapper } from "../shadow-wrapper/ShadowWrapper";

class NlpAnswerTextInput extends React.Component<INlpAnswerTextInputProps, INlpAnswerTextInputState> {
    public readonly state: Readonly<INlpAnswerTextInputState> = {
        element: this.props.innerRef ?? React.createRef<HTMLInputElement>(),
    };

    public componentDidMount() {
        this.resize();
    };

    public render() {
        return (
                    <div className="md-editor-container" data-color-mode="light">
                        <MDEditor
                            height={200}
                            value={this.props.value}
                            onChange={this._onChangeHandler}
                            previewOptions={{
                                linkTarget: "_blank",
                            }}
                            defaultTabEnable={true}
                            components={{
                                preview: (source, state, dispath) => {
                                    return <ShadowWrapper><MDEditor.Markdown source={source} linkTarget="_blank" className="w-md-editor-preview" disallowedElements={['script']} unwrapDisallowed={true} /></ShadowWrapper>
                                }
                            }}
                        />
                    </div>
        );
    }

    private _onChangeHandler = (event?: string): void => {
        this.props.onChange(event ?? "");
        this.resize();
    };

    public resize = () => {
        const element: HTMLInputElement | null = this.state.element.current;
        element?.style.setProperty("height", "auto");
        element?.style.setProperty("height", element?.scrollHeight + "px");
    };
}

export default NlpAnswerTextInput;